import type { MetaFunction } from "@remix-run/node";

export const meta: MetaFunction = () => {
  return [
    { title: "業務分野 - 国際離婚・刑事・金融・不動産 | 法務法人フィサン" },
    { name: "description", content: "法務法人フィサンの専門業務分野。国際離婚・家事紛争、経営権紛争、金融・企業法務、不動産PF、民事・刑事事件において日本語で対応可能。" },
    { name: "keywords", content: "業務分野, 国際離婚, 家事紛争, 経営権紛争, 金融法務, 企業法務, 不動産PF, 民事事件, 刑事事件" },
    { property: "og:title", content: "業務分野 | 法務法人フィサン" },
    { property: "og:description", content: "国際離婚・家事紛争、経営権紛争、金融・企業法務、不動産PF、民事・刑事事件において専門的なサービスを提供します。" },
    { property: "og:type", content: "website" },
    { property: "og:url", content: "https://jp-hwisang.co.kr/ja/services" },
    { property: "og:image", content: "https://jp-hwisang.co.kr/images/jp-hwisang-card.jpg" },
    { property: "og:locale", content: "ja_JP" },
    { name: "twitter:card", content: "summary_large_image" },
    { name: "robots", content: "index, follow" },
  ];
};

export default function JapanPracticeAreas() {
  const practiceAreas = [
    {
      title: '家事紛争',
      slug: 'family',
      intro: '家族に関する法律問題は、人生の中で最も繊細で個人的な問題です。',
      description: '輝相（フィサン）は、離婚・相続・親権・財産分割などの家事事件において、依頼者の立場と感情に寄り添い、法的にも心理的にも支えるパートナーを目指しています。',
      content: [
        '離婚では、財産分与・慰謝料・親権などの複雑な問題に加え、国際離婚では準拠法や管轄の判断が重要です。日韓両国の法制度と文化に精通した弁護士が、日本・韓国いずれの手続きにも対応し、依頼者の権利を守ります。',
        '相続では、遺産分与や遺言作成、税務（相続税・贈与税）を含めた包括的サポートを提供。日本に資産を持つ方や国際相続にも対応し、両国の制度を踏まえた最適な解決策を提案します。',
        '日韓の法律と文化に精通した輝相は、透明性と誠実さをもって依頼者の不安を解消し、人生の転機に寄り添う信頼できるパートナーとして温かい支援を提供します。'
      ],
    },
    {
      title: '経営権紛争',
      slug: 'management',
      intro: '企業の経営権をめぐる紛争は、株主間の対立、取締役会での意見の不一致、M&Aや企業再編など、多様な要因から発生し、企業の安定や信頼性に深刻な影響を及ぼします。',
      description: '輝相（フィサン）は、商法・企業経営に精通した弁護士チームが、迅速かつ専門的な対応で依頼者の利益を守ります。',
      content: [
        '主な支援内容として、株主総会での議決権行使や議事運営をめぐる紛争対応、M&A・企業再編における法的戦略や契約交渉、ガバナンス体制や内部統制の構築支援、経営権に関する仮処分申立てなど、実務的な法的サポートを幅広く提供します。',
        '経営権紛争は法的論争にとどまらず、企業の信頼や評判にも影響するデリケートな問題です。輝相は、法的専門性と経営実態の理解を兼ね備え、現実的で持続可能な解決策を提示します。',
        'さらに、日韓両国の法制度と商慣行に通じた弁護士が、日本企業や投資家の韓国での経営課題に対し、安定と信頼を重視した支援を行います。'
      ],
    },
    {
      title: '金融・企業顧問及び訴訟',
      slug: 'finance-corporate',
      intro: '韓国でのビジネスには、法制度や商慣習の違いから予期せぬリスクが伴います。',
      description: '輝相（フィサン）は、金融・企業分野に特化した専門チームが、企業活動における多様な法律問題に迅速かつ戦略的に対応し、ワンストップで支援します。',
      content: [
        '当事務所は、銀行・保険・投資機関などの金融機関や一般企業に対し、契約書作成、取引構造の法的リスク分析、株主・取締役関連の紛争対応など、包括的な法務サポートを提供しています。',
        'また、金融・投資関連の紛争や規制対応にも注力し、複雑な取引トラブルの解決や金融当局への対応、規制リスクの予防策を支援。企業の信頼性と透明性を維持するため、実務的かつ現実的な解決策を提案します。',
        'さらに、日韓両国の法律制度と企業文化に精通した弁護士が、日本企業の韓国進出を全面的に支援。言語や文化の壁を超え、法的安定性と信頼性を確保しながら、企業の成長と持続的な成功を力強くサポートします。'
      ],
    },
    {
      title: '企業金融及び不動産PF',
      slug: 'real-estate-pf',
      intro: '輝相（フィサン）は、企業金融および不動産プロジェクトファイナンス（PF）の分野で豊富な経験を持つ専門チームが、複雑な取引構造や法的課題に対して総合的なソリューションを提供します。',
      description: '企業や投資家が韓国で安心して事業を進められるよう、企画から実行・運用まで一貫した法的支援を行います。',
      content: [
        '不動産開発においては、契約構成、資金調達、許認可対応など、プロジェクト全体を通じた法務サポートを提供。韓国の不動産市場と規制に精通した弁護士が、安全で効率的な開発戦略を立案します。',
        'また、不動産投資・企業金融・ファンド運営に関しては、金融規制対応や投資ストラクチャー設計など、専門的なリーガルサービスをワンストップで提供します。',
        'さらに、日韓両国の法制度と投資環境を理解する弁護士が、日本企業や投資家の韓国事業を支援し、信頼と透明性を重視した法的アドバイスで事業と投資の成功を力強くサポートします。'
      ],
    },
    {
      title: '民事事件',
      slug: 'civil',
      intro: '民事紛争は、日常生活やビジネスの中で突然発生し、大きなストレスや損失をもたらすことがあります。',
      description: '輝相（フィサン）は、契約、損害賠償、不動産、労働、投資など幅広い分野の民事事件において、依頼者の立場を守りながら最適な解決を目指します。',
      content: [
        '契約不履行や取引トラブルなどの紛争には、契約書の分析や損害賠償請求を通じて的確に対応します。不動産や建設・再開発に関しては、複雑な関係者調整を含むリスク管理から訴訟まで、総合的なサポートを提供します。',
        'また、労働や投資、企業間取引など経済活動に関する紛争では、迅速な交渉と訴訟対応により、依頼者にとって最も現実的で有利な解決策を導きます。必要に応じて仮差押・仮処分などの保全措置を講じ、権利を確実に保護します。',
        '輝相の弁護士は、日韓両国の法制度と文化を理解し、日本語で丁寧に対応します。日本人依頼者が安心して法的手続きを進められるよう支援し、誠実さと確かな成果で信頼に応えます。'
      ],
    },
    {
      title: '刑事事件',
      slug: 'criminal',
      intro: '刑事事件に巻き込まれることは、誰にとっても大きな不安を伴います。特に韓国では、言語や制度の違いにより、その不安はさらに大きくなります。',
      description: '輝相（フィサン）は、軽微な事件から重大犯罪まで幅広く対応し、経験豊富な弁護士が事実を丁寧に把握し、最善の結果を導く戦略を立てます。',
      content: [
        '刑事事件では初動が重要です。輝相は、警察・検察の捜査段階から裁判まで一貫してサポートし、有利な解決を目指します。また、保釈や逮捕・拘留に関しては、専門知識をもとに迅速な法的助言を行い、不当な拘束を防ぎます。',
        'さらに、被疑者だけでなく犯罪被害者のための支援にも注力し、告訴・被害届の代理や損害賠償請求などを通じて、正当な権利の実現を支援します。',
        '輝相は、日本人のお客様が安心して法的対応を受けられるよう、言語・文化の両面から支え、どのような状況でも「あなたの味方」として最善を尽くします。'
      ],
    },
  ];

  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="bg-white border-b border-gray-200">
        <div className="container mx-auto px-4 py-4">
          <div className="flex flex-col md:flex-row md:justify-between md:items-center gap-4">
            <a href="/ja" className="flex items-center justify-center md:justify-start">
              <img src="/images/no-padding-logo.png" alt="法務法人フィサン" className="h-8 w-auto opacity-90" />
            </a>

            <div className="flex items-center justify-center md:justify-end gap-4 md:gap-6">
              <nav className="flex items-center gap-4 md:gap-6 text-sm">
                <a href="/ja/office" className="text-gray-700 hover:text-black whitespace-nowrap">事務所・所在地</a>
                <a href="/ja/services" className="text-black font-medium whitespace-nowrap">業務分野</a>
                <a href="/ja/blog" className="text-gray-700 hover:text-black whitespace-nowrap">法律ブログ</a>
              </nav>
              <a
                href="https://jp-hwisang.co.kr"
                target="_blank"
                rel="noopener noreferrer"
                className="px-3 py-1.5 border border-gray-300 hover:border-gray-900 text-gray-700 hover:text-black text-sm transition-colors whitespace-nowrap"
              >
                한국어
              </a>
            </div>
          </div>
        </div>
      </header>

      {/* Title Section */}
      <section className="py-20 px-4">
        <div className="max-w-4xl mx-auto">
          <a href="/ja" className="inline-flex items-center text-gray-500 hover:text-gray-900 mb-8 text-sm transition-colors">
            <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
            </svg>
            ホームに戻る
          </a>
          <div className="text-center">
            <h1 className="text-4xl font-serif mb-8 text-gray-900 tracking-wide">業務分野</h1>
            <div className="w-16 h-px bg-gray-400 mx-auto mb-12"></div>
            <p className="text-base text-gray-700 leading-relaxed">
              法務法人フィサンは様々な法律分野において専門的なサービスを提供しています。<br />
              各分野別の専門弁護士が最善を尽くして依頼者の権利を守ります。
            </p>
          </div>
        </div>
      </section>

      {/* Practice Areas List */}
      <section className="py-16 px-4">
        <div className="max-w-5xl mx-auto space-y-20">
          {practiceAreas.map((area, index) => (
            <div key={index} className="border-b border-gray-200 pb-16 last:border-b-0">
              <div className="mb-8">
                <h2 className="text-3xl font-serif mb-6 text-gray-900">{area.title}</h2>
                <div className="w-12 h-px bg-gray-400 mb-8"></div>
                <p className="text-base text-gray-700 leading-relaxed mb-4">
                  {area.intro}
                </p>
                <p className="text-base text-gray-700 leading-relaxed font-medium">
                  {area.description}
                </p>
              </div>

              <div className="space-y-6 mb-8">
                {area.content.map((paragraph, idx) => (
                  <p key={idx} className="text-sm text-gray-600 leading-relaxed">
                    {paragraph}
                  </p>
                ))}
              </div>

              <div className="mt-8">
                <a href={`/ja/services/${area.slug}`}>
                  <button className="px-8 py-3 border border-gray-900 text-gray-900 hover:bg-gray-900 hover:text-white transition-colors text-sm tracking-wider">
                    詳細を見る
                  </button>
                </a>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Bottom Message */}
      <section className="py-20 px-4 bg-gray-50">
        <div className="max-w-3xl mx-auto text-center">
          <div className="w-16 h-px bg-gray-400 mx-auto mb-8"></div>
          <p className="text-xl font-medium text-gray-900 mb-4 leading-relaxed">
            専門性と信頼性
          </p>
          <p className="text-base text-gray-700 leading-relaxed">
            各分野別の専門弁護士が共に働き、<br />
            最高の法律サービスを提供します
          </p>
        </div>
      </section>

      {/* Footer */}
      <footer className="border-t border-gray-200 bg-white py-12">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-center md:text-left">
            <div>
              <h5 className="text-base font-medium mb-4 text-gray-900">法務法人フィサン</h5>
              <p className="text-sm text-gray-600 leading-relaxed">
                韓国を代表する法律事務所として、<br />
                専門的で信頼できる法律サービスを提供します
              </p>
            </div>
            <div>
              <h5 className="text-base font-medium mb-4 text-gray-900">業務分野</h5>
              <ul className="space-y-2 text-sm text-gray-600">
                <li>刑事事件</li>
                <li>金融・不動産</li>
                <li>経営権紛争</li>
                <li>家事事件</li>
              </ul>
            </div>
            <div>
              <h5 className="text-base font-medium mb-4 text-gray-900">お問い合わせ</h5>
              <ul className="space-y-2 text-sm text-gray-600">
                <li>電話: 010-4729-3573</li>
                <li>Email: mgkim@hwisang.co.kr</li>
                <li>住所: ソウル特別市江南区永東大路611, 13階</li>
              </ul>
            </div>
          </div>
          <div className="border-t border-gray-200 mt-8 pt-8 text-center">
            <p className="text-xs text-gray-500">&copy; 2024 法務法人フィサン. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  );
}
